<template>
    <div class="col-auto progressContainer">
        <div class="progress w-100" v-if="progress || false === hideZero">
            <div class="progress-bar bg-success"
                 :style="{ width: progress + '%' }"
            ></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ProgressBar',
        data() {
            return {};
        },
        props     : {
            progress: {
                type: Number,
                default: null,
            },
            hideZero: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>
